import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const client = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
});

export default client;

export const listOracles = () => client.get("/oracles").then((r) => r.data);
export const askOracle = (oracle, question, email) =>
  client.post("/oracles/ask", { oracle, question, email: email || null }).then((r) => r.data);

export const chatBarde = (message, session_id, email, lang = "fr") =>
  client.post("/chat/barde", { message, session_id: session_id || null, email: email || null, lang }).then((r) => r.data);
export const chatDruide = (message, session_id, email, lang = "fr") =>
  client
    .post("/chat/druide", { message, session_id: session_id || null, email: email || null, lang })
    .then((r) => r.data);
export const chatDruideUsage = (email) =>
  client
    .get("/chat/druide/usage", { params: email ? { email } : {} })
    .then((r) => r.data);
export const chatDruideClear = (session_id) =>
  client.post("/chat/druide/clear", { session_id: session_id || null }).then((r) => r.data);
export const chatBardeHistory = (session_id, email) =>
  client
    .get("/chat/barde/history", { params: session_id ? { session_id } : email ? { email } : {} })
    .then((r) => r.data);
export const chatDruideHistory = (session_id, email) =>
  client
    .get("/chat/druide/history", { params: session_id ? { session_id } : email ? { email } : {} })
    .then((r) => r.data);

export const accountStatus = (email) =>
  client.get("/account/status", { params: { email } }).then((r) => r.data);

export const checkoutStart = (lookup_key, email) =>
  client
    .post("/payments/checkout", { lookup_key, email, origin_url: window.location.origin })
    .then((r) => r.data);
export const checkoutStatus = (session_id) =>
  client.get(`/payments/status/${session_id}`).then((r) => r.data);

export const getCaptcha = () => client.get("/captcha").then((r) => r.data);
export const clearSession = (session_id, email) => {
  const url = `${API}/session/clear`;
  const body = JSON.stringify({ session_id: session_id || null, email: email || null });
  // Use sendBeacon so it fires reliably on page unload
  if (typeof navigator !== "undefined" && navigator.sendBeacon) {
    const blob = new Blob([body], { type: "application/json" });
    navigator.sendBeacon(url, blob);
    return Promise.resolve();
  }
  return client.post("/session/clear", JSON.parse(body));
};

export const subscribeNewsletter = (payload) =>
  client.post("/newsletter", payload).then((r) => r.data);

// Taverne / Pub du Barde (same backend endpoints)
export const taverneList = (lang = "fr") =>
  client.get("/taverne/poems", { params: { lang } }).then((r) => r.data);
export const taverneUsage = (email) =>
  client
    .get("/taverne/usage", { params: email ? { email } : {} })
    .then((r) => r.data);
export const taverneListen = (poem_id, email) =>
  client
    .post("/taverne/listen", { poem_id, email: email || null })
    .then((r) => r.data);

// Suantraí — free unlimited sleep lullabies, no auth
export const suantraiPoems = (lang = "fr") =>
  client.get("/suantrai/poems", { params: { lang } }).then((r) => r.data);

// Gaïa — freemium Mother-Earth goddess chatbot
export const chatGaia = (message, session_id, email, lang = "fr") =>
  client.post("/chat/gaia", { message, session_id: session_id || null, email: email || null, lang }).then((r) => r.data);
export const chatGaiaUsage = (email) =>
  client
    .get("/chat/gaia/usage", { params: email ? { email } : {} })
    .then((r) => r.data);
export const chatGaiaHistory = (session_id) =>
  client
    .get("/chat/gaia/history", { params: session_id ? { session_id } : {} })
    .then((r) => r.data);
export const chatGaiaClear = (session_id) =>
  client.post("/chat/gaia/clear", { session_id: session_id || null }).then((r) => r.data);

// Le Vate — free anonymous emotional counselor (age-aware for 18+ content)
export const chatVate = (message, session_id, lang = "fr", adult_confirmed = false) =>
  client
    .post("/chat/vate", { message, session_id: session_id || null, lang, adult_confirmed })
    .then((r) => r.data);
export const chatVateHistory = (session_id) =>
  client
    .get("/chat/vate/history", { params: session_id ? { session_id } : {} })
    .then((r) => r.data);
export const chatVateClear = (session_id) =>
  client.post("/chat/vate/clear", { session_id: session_id || null }).then((r) => r.data);

// Le Farfadet — freemium joke chatbot (20/day free, unlimited premium)
export const chatFarfadet = (message, session_id, email, lang = "fr") =>
  client.post("/chat/farfadet", { message, session_id: session_id || null, email: email || null, lang }).then((r) => r.data);
export const chatFarfadetUsage = (email) =>
  client
    .get("/chat/farfadet/usage", { params: email ? { email } : {} })
    .then((r) => r.data);
export const chatFarfadetHistory = (session_id) =>
  client
    .get("/chat/farfadet/history", { params: session_id ? { session_id } : {} })
    .then((r) => r.data);
export const chatFarfadetClear = (session_id) =>
  client.post("/chat/farfadet/clear", { session_id: session_id || null }).then((r) => r.data);
export const chatFarfadetRate = (message_index, joke_snippet, rating, session_id) =>
  client
    .post("/chat/farfadet/rate", { session_id: session_id || null, message_index, joke_snippet, rating })
    .then((r) => r.data);
export const farfadetDaily = (lang = "fr", email = null) =>
  client.get("/farfadet/daily", { params: email ? { lang, email } : { lang } }).then((r) => r.data);
export const farfadetSubscribe = (payload) =>
  client.post("/farfadet/newsletter/subscribe", payload).then((r) => r.data);

// Le Korrigan — freemium arrogant chatbot (20/day free, unlimited premium)
export const chatKorrigan = (message, session_id, email, lang = "fr") =>
  client.post("/chat/korrigan", { message, session_id: session_id || null, email: email || null, lang }).then((r) => r.data);
export const chatKorriganUsage = (email) =>
  client
    .get("/chat/korrigan/usage", { params: email ? { email } : {} })
    .then((r) => r.data);
export const chatKorriganHistory = (session_id) =>
  client
    .get("/chat/korrigan/history", { params: session_id ? { session_id } : {} })
    .then((r) => r.data);
export const chatKorriganClear = (session_id) =>
  client.post("/chat/korrigan/clear", { session_id: session_id || null }).then((r) => r.data);

// Le Grammarien d'Iona — freemium sacred-languages tutor
export const chatGrammarien = (message, session_id, email, lang = "fr") =>
  client
    .post("/chat/grammarien", { message, session_id: session_id || null, email: email || null, lang })
    .then((r) => r.data);
export const chatGrammarienUsage = (email) =>
  client
    .get("/chat/grammarien/usage", { params: email ? { email } : {} })
    .then((r) => r.data);
export const chatGrammarienClear = (session_id) =>
  client.post("/chat/grammarien/clear", { session_id: session_id || null }).then((r) => r.data);
